import type {
	PaymentNonce,
	SavedAch,
	SavedCard,
} from "~/shared/types/payment-types.ts";

import { SavedACHAccount } from "../../payment-method-modal/components/saved-ach-account/saved-ach-account.tsx";
import { SavedCCCard } from "../../payment-method-modal/components/saved-cc-card/saved-cc-card.tsx";

type PaymentSelectedMethodProps = {
	selectedPaymentValue: SavedCard | SavedAch | PaymentNonce | null;
};

export function PaymentSelectedMethod({
	selectedPaymentValue,
}: Readonly<PaymentSelectedMethodProps>) {
	if (!selectedPaymentValue) {
		return null;
	}

	return (
		<div style={{ marginTop: "1rem" }}>
			<h4>Selected Payment Method:</h4>
			{selectedPaymentValue.paymentMethod === "CreditCard" ? (
				<SavedCCCard
					hideSelectionActions
					handleApplyPaymentMethod={() => null}
					savedCard={selectedPaymentValue as SavedCard}
				/>
			) : (
				<SavedACHAccount
					hideSelectionActions
					handleApplyPaymentMethod={() => null}
					savedAch={selectedPaymentValue as SavedAch}
				/>
			)}
		</div>
	);
}
